import { round } from 'lodash-es';

export namespace BasisPointUtil {
  export function numToBP(num: number | string) {
    return round(parseFloat(String(num)) * 10000);
  }

  export function bpToNum(bp: number, precision = 2) {
    return round(bp / 10000, precision);
  }
}
